/* action type */
import type { Action } from '../../store/state/state-manager';

export const OPEN_PROCESS_ACTION = 'OPEN_PROCESS_ACTION';

/* action creator */
export const openProcessAction = (actionPayload: Action['payload']) => {
  return {
    type: OPEN_PROCESS_ACTION,
    payload: actionPayload
  };
};
